export enum PROPOSAL_TYPE {
  PAYROLL_LOAN = 'PAYROLL_LOAN',
  PERSONAL_LOAN = 'PERSONAL_LOAN',
  PAYCHECK_ADVANCE = 'PAYCHECK_ADVANCE',
}
